export default __webpack_public_path__ + "img/repo.7ad6f2fa.webp";